import { useNavigate } from "react-router-dom"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { usePlanLimitations } from "@/hooks/usePlanLimitations"
import { cn } from "@/lib/utils"

interface PlanLimitAlertProps {
    type: 'brands'
    showUpgradeButton?: boolean
    className?: string
}

export function PlanLimitAlert({ 
    type,
    showUpgradeButton = true,
    className = ''
}: PlanLimitAlertProps) {
    const navigate = useNavigate()
    const { limitations, getRemainingLimits } = usePlanLimitations()

    if (!limitations || !getRemainingLimits()) return null

    // const remainingLimits = getRemainingLimits()!

    // console.log('Remaining limits:', remainingLimits)

    const messages = {
        brands: {
            title: "Brand Limit Reached",
            description: `You can create up to ${limitations.max_brands} brand${limitations.max_brands === 1 ? '' : 's'} on your current plan.`
        }
    }

    const { title, description } = messages[type]

    return (
        <Alert variant="destructive" className={cn("flex items-center justify-between", className)}>
            <div>
                <AlertTitle>{title}</AlertTitle>
                <AlertDescription>{description}</AlertDescription>
            </div>
            {showUpgradeButton && (
                <Button 
                    variant="outline" 
                    onClick={() => navigate('/settings')}
                    className="ml-4 bg-white hover:bg-white/90"
                >
                    Upgrade Plan
                </Button>
            )}
        </Alert>
    )
} 